import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Articulo } from "@/shared/types/articulo";

export interface ArticuloAddRequest {
    codigo: string,
    numeroItem?: string,
    rubroId: string,
    nombre: string,
    costo: number,
    iva: number,

    descripcion?: string,
    cantidadMinima?:number | "",
    cantidadPorCaja?: number | "",
    precios: number[],
    imagen?:File|null
}

export async function addArticulo(request: ArticuloAddRequest): Promise<Articulo> {
    await sleep(1000);
    const response = await api.postForm("articulos", request);
    return response.data;
}

export function useAddArticuloMutation(mutationConfig: MutationConfig<Articulo, ArticuloAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addArticulo,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulos"] });
        },
    })
}

export interface AddArticuloMutationProps {
    mutationConfig?: MutationConfig<Articulo, ArticuloAddRequest>
    children?: (mutationResult: MutationResult<Articulo, ArticuloAddRequest>) => ReactNode
}

export function AddArticuloMutation({
    mutationConfig,
    children
}: AddArticuloMutationProps) {
    const mutationResult = useAddArticuloMutation(mutationConfig);
    return children && children(mutationResult);
}